// extracted by mini-css-extract-plugin
export default {"premiumDomainBadge":"RpkwFj","infoIcon":"Wbbagc"};